import SearchFilterTab from '@components/cockpit/panels/notificationSearch/categoryFilters/SearchFilterTab';
import { PeriodFilter } from '@components/cockpit/panels/notificationSearch/filterComponents/AdditionalFilters';
import {
  IdentifierFilter,
  PlatformFilter,
} from '@components/cockpit/panels/notificationSearch/filterComponents/SearchFilters';
import { SearchFilterOptionEnum } from '@components/cockpit/panels/notificationSearch/notificationSearch.types';
import { useNotificationSearchContext } from '@components/cockpit/panels/notificationSearch/NotificationSearchContext';
import { useState } from 'react';

import { NotificationFamilyEnum } from '@/types/data/data.types';

export default function PerimeterFilters() {
  const { filters, displayedFilterOptions } = useNotificationSearchContext();
  const [resetKey, setResetKey] = useState(0);

  return (
    <SearchFilterTab
      category={NotificationFamilyEnum.PERIMETER}
      onReset={() => {
        setResetKey((prev) => prev + 1);
      }}
    >
      {displayedFilterOptions.has(SearchFilterOptionEnum.PLATFORM) && <PlatformFilter />}
      {displayedFilterOptions.has(SearchFilterOptionEnum.ID) && <IdentifierFilter />}
      <PeriodFilter key={`${filters.category}-${resetKey}`} isDetection={false} />
    </SearchFilterTab>
  );
}
